import { render, staticRenderFns } from "./portfolio-content-card.vue?vue&type=template&id=6145e176&scoped=true&"
import script from "./portfolio-content-card.ts?vue&type=script&lang=ts&"
export * from "./portfolio-content-card.ts?vue&type=script&lang=ts&"
import style0 from "./portfolio-content-card.scss?vue&type=style&index=0&id=6145e176&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6145e176",
  null
  
)

export default component.exports